import * as Yup from 'yup';

const headers = [
  {
    label: "Name",
    id: "name"
  },
  {
    label: "Category",
    id: "category"
  },
  {
    label: "SKU",
    id: "sku"
  },
  {
    label: "Price",
    id: "price",
    currency: true
  },
  {
    label: "Stock",
    id: "quantity_in_stock"
  },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  }
];

const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Name",
    type: "text",
    size: {xs: 12, lg: 4},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "category",
    label: "Category",
    type: "text",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    multiline: true,
    rows: 3,
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Product Details",
    name: "product_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "brand",
    label: "Brand",
    type: "text",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "color",
    label: "Color",
    type: "text",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "size",
    label: "Size",
    type: "text",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Price Details",
    name: "price_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "cost",
    label: "Cost",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "price",
    label: "Price",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Stocking Details",
    name: "stock_status",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "quantity_in_stock",
    label: "Quantity in Stock",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "low_stock_threshold",
    label: "Low Stock Threshold",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  }
]

const initialValues = {
  name: '',
  category: '',
  sku: '',
  description: '',
  brand: '',
  color: '',
  size: '',
  cost: "",
  price: "",
  quantity_in_stock: "",
  low_stock_threshold: "",
  is_active: true
}

const schema = Yup.object().shape({
  name: Yup.string().required('Name is Required'),
  category: Yup.string().nullable(),
  // sku: Yup.string(),
  description: Yup.string().nullable(),
  brand: Yup.string().nullable(),
  color: Yup.string().nullable(),
  size: Yup.string().nullable(),
  cost: Yup.number(),
  price: Yup.number(),
  quantity_in_stock: Yup.number(),
  low_stock_threshold: Yup.number(),
  is_active: Yup.boolean()
});

export { headers, filters, fields, schema, initialValues };